export default __webpack_public_path__ + "static/media/customers-3.a742351b.jpg";